// Airport Activity is a read view; the prediction editor/model is administrative.
export function canManageCrowdPrediction(positionKey: unknown): boolean {
  return ["admin", "super_admin"].includes(
    String(positionKey || "")
      .trim()
      .toLowerCase(),
  );
}
export function isCrowdPredictionPath(pathname: string): boolean {
  return (
    pathname === "/crowd-prediction" ||
    pathname.startsWith("/crowd-prediction/")
  );
}
